export default __webpack_public_path__ + "static/media/social-in.1418c3af.png";